export const combineClassNames = (...classNames) => {
  try {
    return classNames.filter(c => c).join(" ");
  } catch (ex) {
    return "";
  }
};

export const getAdaptiveFontSize = ({ screenWidthHooks, fontSize }) => {
  const {
    isSmartphoneScreen,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  } = screenWidthHooks;
  let calculatedFontSize = fontSize;
  //Min Pixel 0
  if (isSmartphoneScreen) {
    calculatedFontSize = fontSize * 0.4;
  }

  //Min Pixel 500
  if (isSmallScreen) {
    calculatedFontSize = fontSize * 0.45;
  }
  //Min Pixel 768
  if (isMediumScreen) {
    calculatedFontSize = fontSize * 0.55;
  }
  //Min Pixel 992
  if (isLargeScreen) {
    calculatedFontSize = fontSize * 0.65;
  }
  //Min Pixel 1200
  if (isExtraLargeScreen) {
    calculatedFontSize = fontSize;
  }
  return `${calculatedFontSize}rem`;
};
